/* RESPONSIBLE TEAM: team-reporting */
import Highcharts, { type Options, type PlotSeriesOptions } from 'highcharts';
import 'highcharts/modules/heatmap';
import 'highcharts/modules/sankey';
import 'highcharts/modules/treemap';
import 'highcharts/highcharts-more';
import PALETTE from '@intercom/pulse/lib/palette';

interface ImprovedPlotSeriesOptions extends PlotSeriesOptions {
  borderRadius: number;
}

const theme: Options = {
  title: undefined,
  credits: undefined,
  chart: {
    style: {
      fontFamily: 'inherit',
      fontSize: '16px',
    },
    backgroundColor: 'transparent',
  },
  plotOptions: {
    area: {
      lineWidth: 1.7,
    },
    line: {
      lineWidth: 1.7,
    },
    series: {
      borderRadius: 0,
      dataLabels: {
        style: {
          fontSize: '11px',
        },
      },
    } as ImprovedPlotSeriesOptions,
  },
  tooltip: {
    borderWidth: 1,
  },
  legend: {
    itemMarginTop: 0,
    itemMarginBottom: 0,
    navigation: {
      style: {
        fontSize: '12px',
        color: PALETTE['text-muted'],
      },
    },
    itemStyle: {
      fontSize: '12px',
      fontWeight: 'normal',
      color: PALETTE['text-muted'],
    },
  },
  xAxis: {
    labels: {
      autoRotation: undefined,
      rotation: undefined,
      padding: 1,
      distance: 8,
      style: {
        color: PALETTE['text-muted'],
        fontSize: '12px',
        textOverflow: undefined,
        whiteSpace: undefined,
      },
      overflow: undefined,
    },
    lineColor: '#ccd6eb',
  },
  yAxis: {
    labels: {
      distance: 8,
      style: {
        color: PALETTE['text-muted'],
        fontSize: '12px',
      },
    },
  },
  colorAxis: {
    labels: {
      distance: 8,
      style: {
        color: PALETTE['text-muted'],
        fontSize: '12px',
      },
    },
  },
  lang: {
    // the default is a space
    thousandsSep: ',',
  },
};

export function initializeHighcharts() {
  Highcharts.setOptions(theme);
}
